import { CLASSES as C, COLORS, CONFIG } from '../../globals/constants';
import { range, select } from 'd3'
import Slide from '../Slide/slide'

import './style.scss';

export default class Card {
  constructor(parent, rangeScale, index) {
    this.parent = parent;
    this.index = index;
    this.rangeScale = rangeScale
    this.slideArray = [] // store Slide instances as member variables to be accessed from App.js
    // card container
    this.parent
      .append('div')
      .attr('class', `${C.CARD}`)
      // statement
      .call(card =>
        card
          .append(`${C.TEXTBOX}`)
          .attr('class', `${C.TEXTBOX}`)
          .html(({ statement }) => statement)
      )
      // domestic or international label and slide row
      .call(card =>
        card
          .append("div")
          .attr("class", `${C.SLIDE}-${C.VIZ}`)
          .call(viz =>
            // domestic or international label
            viz
              .selectAll(`${C.ROW}`)
              .data(d => d.data)
              .join("div")
              .attr("class", `${C.ROW}`)
              .call(row =>
                row
                  .append('div')
                  .attr('class', `${C.ROW}-${C.GROUP}`)
                  .html(d => d.type)
              )
              // slide visualization
              .call(row =>
                row
                  .append('div')
                  .attr('class', `${C.SLIDE}-${C.WRAPPER}`)
                  .each((d, i, s) => { this.slideArray.push(new Slide(select(s[i]), rangeScale(0), rangeScale(d[`${d.type}Diff`]), null, index)) })
              )
          )
      )
  }

}
